import React, { useEffect } from 'react';
import './Reviews.css';

const Reviews = () => {
  useEffect(() => {
    // Check if the script is already in the document
    if (!document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://elfsightcdn.com/platform.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="reviews-section" id="reviews">
      <div className="reviews-content">
        <h2 className="reviews-title">Discover why families love us</h2>
        <div className="review-embed">
          {/* ✅ Use only the Elfsight div here */}
          <div
            className="elfsight-app-46134f35-7f75-447c-89fe-f83f0e560738"
            data-elfsight-app-lazy
          ></div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
